// @flow

import {
  put,
} from 'redux-saga/effects'

import {mapActions} from '../actions'
import cities from '../lib/citys.json'
import districts from '../lib/districts.json'
 
export function* loadCitiesAndDistricts(): Effect {
  yield put(mapActions.setSelectedCity(cities[0]._links.self))
  yield put(mapActions.setCities(cities))
  yield put(mapActions.setDistricts(districts))
}
